import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Layout } from '../components/Layout';

export function Home() {
  const { canManageObjects, isAdmin } = useAuth();
  const actions = [
    ['AR starten', '/ar', 'Scan de QR-code van je model', 'camera', true],
    ['Objectbibliotheek', '/library', 'Bekijk beschikbare 3D-objecten', 'cube', true],
    ['Object toevoegen', '/admin/new', 'Upload model en afbeelding', 'plus', canManageObjects],
    ['QR-codes beheren', '/admin', 'Download PNG of printbare PDF', 'marker', canManageObjects],
    ['Gebruikers', '/users', 'Accounts, rollen en toegang beheren', 'users', isAdmin],
    ['Cardboard Mode', '/ar?cardboard=1', 'Experimentele stereoweergave', 'glasses', true],
    ['Instellingen', '/settings', 'Wachtwoord, camera en weergave', 'settings', true]
  ].filter((item) => item[4]);
  return <Layout><main className="home"><section className="hero"><div className="eyebrow">PRIVATE · SELF-HOSTED · WEB AR</div><h1>Leg digitale objecten<br/><em>op de echte wereld.</em></h1><p>Een afgeschermde AR-omgeving voor jouw eigen gebruikers, modellen en markers.</p><Link className="primary large" to="/ar">Open camera <span>→</span></Link></section>
    <section className="action-grid">{actions.map(([title, href, text, icon]) => <Link to={String(href)} className="action-card" key={String(title)}><span className={'icon ' + icon} aria-hidden="true"/><div><h2>{title}</h2><p>{text}</p></div><b>↗</b></Link>)}</section>
    <footer><span>OpenAR v0.2</span><span>Beveiligde accounts · AR.js · SQLite</span></footer></main></Layout>;
}
